module.exports = __webpack_public_path__ + "static/media/pfp-kyo.150068b1.jpeg";